import React, { useContext } from "react";
import AsyncSelect from "react-select/async";
import { CustomAsyncSelectProps } from "../../../entities/CustomSelect";
import { customStyles } from "../CustomStyles";
import { TranslationContext } from "../../../context/TranslationContext";
import { TranslationContextInterface } from "../../../entities/Language";
import { getValueForKey } from "../../../context/translationsUtils";
import ImageComponent from "../../../UI/ImageComponent";

const CustomAsyncSelect: React.FC<CustomAsyncSelectProps> = ({
  onChange,
  loadOptions,
  id,
  ...props
}: CustomAsyncSelectProps) => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  return (
    <AsyncSelect
      {...props}
      loadOptions={loadOptions}
      onChange={(option) => onChange(option)}
      styles={customStyles}
      value={null}
      components={{
        Option: (option: any) => {
          const { children, innerProps, data } = option;
          const { type, name, image } = data;
          return (
            <div className="async-option" {...innerProps}>
              <div className="async-option__wrapper">
                <div className="async-option__image">
                  <ImageComponent name={name} url={image} />
                </div>
                <div className="async-option__right">
                  <span>{children}</span>
                  <span>
                    {getValueForKey(
                      translations,
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                      `search.${type.toUpperCase()}`,
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        },
      }}
      id={id}
    />
  );
};

export default CustomAsyncSelect;
